import sl from "../../../../components/startups-landing/startups-landing-sections.module.css"
import textStyles from "../../../../shared/styles/section-text.module.css"
import styles from "./build-profile.module.css"

const BuildProfile = () => {
	return (
		<section id="build-profile" className={styles.section}>
			<div className={`container ${sl.sectionContainer}`}>
				<header className={styles.sectionHeader}>
					<div className={styles.headerMain}>
						<div className={sl.label}>Build profile</div>
						<h2 className={styles.title}>
							<span className={styles.titleLine}>Your professional profile.</span>
							<span className={styles.titleLine}>Built once.</span>
							<span className={styles.titleLine}>Used everywhere.</span>
						</h2>
						<p className={`${sl.bodyLg} ${textStyles.regularDescription} ${styles.lead}`}>
							Import from LinkedIn, upload a resume, or build from scratch. Your profile unlocks the Techcore
							Network, a curated pool of growing companies hiring right now. Private by default and shared only
							when there's a match worth your attention.
						</p>
					</div>
				</header>

				<div className={styles.guide}>
					<article className={styles.card}>
						<div className={styles.cardArt} aria-hidden>
							<svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.cardSvg}>
								<rect x="10" y="14" width="100" height="52" rx="8" fill="white" stroke="rgba(0,0,0,0.1)" />
								<rect x="22" y="26" width="60" height="8" rx="3" fill="rgba(13,27,42,0.14)" />
								<rect x="22" y="40" width="52" height="6" rx="2" fill="rgba(13,27,42,0.08)" />
								<rect x="22" y="50" width="40" height="6" rx="2" fill="rgba(13,27,42,0.06)" />
								<circle cx="93" cy="42" r="9" fill="#e8f4ff" stroke="#bfe5ff" />
								<path
									d="M89.8 42.1l2.3 2.3 4.3-4.7"
									stroke="#00a5ff"
									strokeWidth="1.8"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						<div className={styles.cardBody}>
							<h3 className={styles.cardTitle}>Kate-powered matching</h3>
							<p className={styles.cardDesc}>
								The richer your profile, the sharper Kate&apos;s matches. She reads everything and learns what you
								actually want over time.
							</p>
						</div>
					</article>

					<article className={styles.card}>
						<div className={styles.cardArt} aria-hidden>
							<svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.cardSvg}>
								<rect x="10" y="14" width="100" height="52" rx="8" fill="white" stroke="rgba(0,0,0,0.1)" />
								<rect x="22" y="26" width="62" height="8" rx="3" fill="rgba(13,27,42,0.12)" />
								<rect x="22" y="40" width="44" height="6" rx="2" fill="rgba(13,27,42,0.07)" />
								<rect x="22" y="50" width="30" height="6" rx="2" fill="rgba(13,27,42,0.06)" />
								<rect x="98" y="10" width="18" height="18" rx="6" fill="#e8f4ff" stroke="#bfe5ff" />
								<path
									d="M107 23v-8M107 15l-3 3M107 15l3 3"
									stroke="#00a5ff"
									strokeWidth="1.6"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						<div className={styles.cardBody}>
							<h3 className={styles.cardTitle}>Shareable link</h3>
							<p className={styles.cardDesc}>
								A clean, always-current profile link you can send to anyone. No more attaching outdated resume
								versions to emails.
							</p>
						</div>
					</article>

					<article className={styles.card}>
						<div className={styles.cardArt} aria-hidden>
							<svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.cardSvg}>
								<rect x="10" y="14" width="100" height="52" rx="8" fill="white" stroke="rgba(0,0,0,0.1)" />
								<rect x="22" y="26" width="62" height="8" rx="3" fill="rgba(13,27,42,0.12)" />
								<rect x="22" y="40" width="44" height="6" rx="2" fill="rgba(13,27,42,0.07)" />
								<rect x="22" y="50" width="30" height="6" rx="2" fill="rgba(13,27,42,0.06)" />
								<rect x="98" y="52" width="18" height="18" rx="6" fill="#e8f4ff" stroke="#bfe5ff" />
								<path
									d="M107 57v8M107 65l-3-3M107 65l3-3"
									stroke="#00a5ff"
									strokeWidth="1.6"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						<div className={styles.cardBody}>
							<h3 className={styles.cardTitle}>PDF export</h3>
							<p className={styles.cardDesc}>
								Export a polished PDF any time and use it however works for you. Apply the traditional way,
								attach to proposals, share with clients.
							</p>
						</div>
					</article>
				</div>
			</div>
		</section>
	)
}

export default BuildProfile
